import { render, staticRenderFns } from "./MatiPopup.vue?vue&type=template&id=ae9a31b6&"
import script from "./MatiPopup.vue?vue&type=script&lang=js&"
export * from "./MatiPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports